import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { SignInSteps } from '@/models/SignInSteps'
import { UserCredentials } from '@/models/User'
import { AuthState } from './authTypes'

const initialState: AuthState = {
	isLoading: false,
	isAuth: false,
	signInStep: SignInSteps.login,
	credentials: {
		login: '',
		password: ''
	},
	authEmail: null
}

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setLoading: (state, { payload }: PayloadAction<boolean>) => {
			state.isLoading = payload
		},
		setSignInStep: (state, { payload }: PayloadAction<SignInSteps>) => {
			state.signInStep = payload
		},
		setCredentials: (
			state,
			{ payload }: PayloadAction<Partial<UserCredentials>>
		) => {
			state.credentials = {
				...state.credentials,
				...payload
			}
		},
		setAuth: (state, { payload }: PayloadAction<boolean>) => {
			state.isAuth = payload
		},
		setAuthEmail: (state, { payload }: PayloadAction<string | null>) => {
			state.authEmail = payload
		}
	}
})

export const { actions: authActions } = authSlice

export default authSlice
